import React from 'react';
import { useSelector } from "react-redux";

export const useRole = () => {
  return useSelector((state) => state.account.user.roles);
}
